import { SlotStates } from "../api/models/ScheduleSlotModel";
import StudentModel from "../api/models/StudentModel";
import ApiDateParser from "../helpers/parsers/apiDateParser";
import CalendarScheduleModel from "../models/CalendarScheduleModel";
import CalendarScheduleSlotModel from "../models/CalendarScheduleSlotModel";

const MAX_SLOTS_NUMBER = 24; // Number of hours per day because each slot is one hour duration
export default class SchedulingService {
  schedule: CalendarScheduleModel;
  student: StudentModel;
  maxSlotsPerDay: number;
  constructor(
    schedule: CalendarScheduleModel,
    student: StudentModel,
    maxSlotsPerDay?: number
  ) {
    this.schedule = schedule;
    this.student = student;
    this.maxSlotsPerDay = maxSlotsPerDay || MAX_SLOTS_NUMBER;
  }

  reserveSlot(slot: CalendarScheduleSlotModel) {
    const scheduledSlotsNumber = this.schedule.countScheduledSlotsOnDay(
      slot.dayOfWeekName
    );
    if (scheduledSlotsNumber >= this.maxSlotsPerDay) return;

    let deletedSlot: CalendarScheduleSlotModel | undefined =
      this.schedule.deleteSlot(slot.Uuid);
    if (!!deletedSlot) {
      let newSlot: CalendarScheduleSlotModel = new CalendarScheduleSlotModel({
        startTime: deletedSlot.startTime,
        endTime: deletedSlot.endTime,
        dayOfWeek: deletedSlot.dayOfWeekName,
        id: deletedSlot.id,
        student: this.student,
        state: SlotStates.upcoming,
      });
      console.log("deletedSlot", deletedSlot);
      this.schedule.addSlot(newSlot);
      if (scheduledSlotsNumber === this.maxSlotsPerDay - 1) {
        this.schedule.lockDay(newSlot.dayOfWeekName);
      }
    }
  }

  unReserveSlot(slot: CalendarScheduleSlotModel) {
    let deletedSlot: CalendarScheduleSlotModel | undefined =
      this.schedule.deleteSlot(slot.Uuid);
    if (deletedSlot) {
      let newSlot: CalendarScheduleSlotModel = new CalendarScheduleSlotModel({
        startTime: deletedSlot.startTime,
        endTime: deletedSlot.endTime,
        dayOfWeek: deletedSlot.dayOfWeekName,
        id: deletedSlot.id,
        state: SlotStates.available,
      });
      this.schedule.addSlot(newSlot);
      this.schedule.unlockDay(newSlot.dayOfWeekName);
    }
  }

  isReservedSlot(slot: CalendarScheduleSlotModel) {
    return this.schedule.findSlot(slot.Uuid)?.student?.id === this.student.id;
  }

  toggleSlot(slot: CalendarScheduleSlotModel) {
    !!this.isReservedSlot(slot)
      ? this.unReserveSlot(slot)
      : this.reserveSlot(slot);
  }
  toggleOwnSlot(slot: CalendarScheduleSlotModel) {
    if (slot?.state === SlotStates.done) {
      this.reserveSlot(slot);
    } else {
      this.toggleSlot(slot);
    }
  }

  getScheduledSlots(): CalendarScheduleSlotModel[] {
    return this.schedule.slots.filter((slot) => !!slot.student);
  }

  hasScheduledSlots(): boolean {
    return this.getScheduledSlots().length > 0;
  }

  generateApiSchedule(tutorId: string | number): any {
    let apiSchedule = {
      tutor_id: tutorId,
      schedule_slots_attributes: this.getScheduledSlots().map((slot) => {
        return {
          day_of_the_week: slot.dayOfWeekName,
          start_time: ApiDateParser.normalize(
            ApiDateParser.toApiDate(slot.startTime)
          ),
          end_time: ApiDateParser.normalize(
            ApiDateParser.toApiDate(slot.endTime)
          ),
        };
      }),
    };
    return apiSchedule;
  }
}
